import React from "react";
import { Box, Paper, Typography } from "@mui/material";
import LayersOutlinedIcon from "@mui/icons-material/LayersOutlined";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import LocalMallOutlinedIcon from "@mui/icons-material/LocalMallOutlined";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import { STORAGE_BUCKET, IMG_PLACEHOLDER } from "../../common/constants";
import { getCustomerName } from "../../common/util";
import ItemProgress from "./ItemProgress";
import { MetaSegment, metaRowSx } from "../../baker/components/BakerOrderSummary";

export default function KitchenItemSummary(props) {
  const { item, onProgressChange, onItemSelect } = props;

  const image = item.images?.find(Boolean) || `${STORAGE_BUCKET}${IMG_PLACEHOLDER}`;
  const title = `${item.quantity || 1}x ${item.title || item.type}`;
  const fulfillmentType = item.fulfillment?.type;
  const fulfillmentTime = item.fulfillment?.time || "";
  const customerName = getCustomerName(item.customer);

  const stopNavigate = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  return (
    <Box my={2}>
      <Paper elevation={0} sx={{ position: "relative" }}>
        <Box
          component={onItemSelect ? "button" : "div"}
          type={onItemSelect ? "button" : undefined}
          onClick={onItemSelect ? () => onItemSelect(item) : undefined}
          sx={{
            display: "block",
            width: "100%",
            border: "none",
            background: "none",
            textAlign: "left",
            font: "inherit",
            color: "inherit",
            textDecoration: "none",
            p: 2,
            pb: 6,
            cursor: onItemSelect ? "pointer" : undefined,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "flex-start", columnGap: 2 }}>
            <Box
              sx={{
                flex: "0 0 auto",
                width: { xs: "33.333%", sm: "25%" },
              }}
            >
              <img
                alt=""
                src={image}
                style={{ width: "100%", aspectRatio: "1", objectFit: "cover", display: "block" }}
              />
            </Box>
            <Box sx={{ flex: "1 1 0", minWidth: 0, pr: 6 }}>
              <Typography variant="h6" noWrap title={title}>
                {title}
              </Typography>
              <Box sx={{ color: "#888", minWidth: 0 }}>
                {customerName && (
                  <Typography variant="overline" sx={metaRowSx}>
                    <MetaSegment>
                      <PersonOutlinedIcon style={{ fontSize: "1.2rem" }} />
                      {customerName}
                    </MetaSegment>
                  </Typography>
                )}
                {fulfillmentTime && (
                  <Typography variant="overline" sx={metaRowSx}>
                    <MetaSegment>
                      {fulfillmentType === "delivery" ? (
                        <LocalShippingOutlinedIcon style={{ fontSize: "1.2rem" }} />
                      ) : (
                        <LocalMallOutlinedIcon style={{ fontSize: "1.2rem" }} />
                      )}
                      {fulfillmentTime}
                    </MetaSegment>
                  </Typography>
                )}
                {item.itemCount > 1 && (
                  <Typography variant="overline" sx={metaRowSx}>
                    <MetaSegment>
                      <LayersOutlinedIcon style={{ fontSize: "1.2rem" }} />
                      {`(${item.itemIndex + 1} of ${item.itemCount}) items in order`}
                    </MetaSegment>
                  </Typography>
                )}
              </Box>
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            position: "absolute",
            right: 8,
            bottom: 8,
            zIndex: 2,
            width: 40,
            height: 40,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={stopNavigate}
          onMouseDown={stopNavigate}
        >
          <ItemProgress
            key={item.progress.step}
            orderId={item.orderId}
            item={item}
            itemIndex={item.itemIndex}
            progress={item.progress}
            onChange={(data) => onProgressChange(item.orderId, data)}
            size={40}
          />
        </Box>
      </Paper>
    </Box>
  );
}
